import { TRANS_WEBP_STR } from '@commonPackage/components';

export const CDN = {
  closeButton: `https://static.fuxi.netease.com/yaotai/portal/index/lhzpp6jj_227167.png?${TRANS_WEBP_STR}`,
};
